var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../../core';
import { Prop } from 'vue-property-decorator';
import CoverItem from './CoverItem';
import { IDomState } from '../../../store/DomState';
let ChannelItem = class ChannelItem extends VueType {
    get renderList() {
        var _a, _b, _c;
        const list = ((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.vecCtrlList[0]) === null || _b === void 0 ? void 0 : _b.vecCtrlTabList[0]) === null || _c === void 0 ? void 0 : _c.vecCtrlItemList) || null;
        return list;
    }
    render() {
        var _a, _b;
        const { data } = this;
        if ((_a = this.renderList) === null || _a === void 0 ? void 0 : _a.length) {
            return <div class="channel_item">
            <h3 class="channel_item_title">{data.strShowName}</h3>
            <div>
                {(_b = this.renderList) === null || _b === void 0 ? void 0 : _b.map((item, index) => <CoverItem data={item} index={index} tabIndex={this.index}></CoverItem>)}
            </div>
        </div>;
        }
    }
};
__decorate([
    Prop()
], ChannelItem.prototype, "data", void 0);
__decorate([
    Prop()
], ChannelItem.prototype, "index", void 0);
__decorate([
    IDomState
], ChannelItem.prototype, "domState", void 0);
ChannelItem = __decorate([
    Component
], ChannelItem);
export default ChannelItem;
